export const benchmarkLevels = [
  { name: "Meget svak", color: "#b04f4f" },
  { name: "Svak", color: "#e38e4b" },
  { name: "Tilfredstillende", color: "#eabb3b" }, // use #f2d664, but the other one for text
  { name: "God", color: "#82AA63" }, // 82AA63 // origin #9ec880
  { name: "Meget god", color: "#548a3e" },
]
